export function loadClarity(projectId: string) {
  if (!projectId) return;

  const existingInline = document.querySelector(`script[data-clarity-id="${projectId}"]`);
  if (existingInline) {
    return;
  }

  const claritySnippet = `
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${projectId}");
  `;

  const inlineScript = document.createElement('script');
  inlineScript.setAttribute('type', 'text/javascript');
  inlineScript.setAttribute('data-clarity-id', projectId);
  inlineScript.text = claritySnippet.trim();

  document.head.appendChild(inlineScript);
}
